import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchObtenerCategoria = async(id) => {
    try {
        const response = await axios.get(`${API_URL}/api/convocatoria/obtenerCategoria/${id}`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchCategoriasConvocatoriaFilters = async (paginaActual, registrosPorPag,busqueda,nivel,anexo,numSubcategorias, ordenarColumna, orden) => {
    
    try {
        const response = await axios.post(`${API_URL}/api/convocatoria/categorias/filters`, {

            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "nivel": nivel,
            "anexo": anexo,
            "numSubcategorias": numSubcategorias,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});


        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearCategoria = async (formData) => {
    console.log("formData", formData);
    try {
        const response = await axios.post(`${API_URL}/api/convocatoria/crearCategoria`, formData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchEditarCategoria = async (formData) => {
    console.log("formData", formData);
    try {
        const response = await axios.put(`${API_URL}/api/convocatoria/editarCategoria/${formData.IdCategoria}`, formData, {

            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }

        });

        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchActualizarCategorias = async (ids,campoValor) => {
    console.log("campoValor",campoValor);
    try {
        const response = await axios.post(`${API_URL}/api/convocatoria/actualizarCategoriasEnCadena`, {
            ids: ids,
            campo: campoValor.atributo,
            valor: campoValor.valor
        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

